(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4540],{

/***/ 9011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ o; },
/* harmony export */   "h": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var _utils_can_use_dom_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53586);
var o=(e=>(e.mobile="mobile",e.desktop="desktop",e))(o||{});function t(){let e=!1;return function(i){(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(i)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(i.substr(0,4)))&&(e=!0)}(navigator.userAgent||navigator.vendor||window.opera),e}const m=_utils_can_use_dom_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z&&t()?"mobile":"desktop";function n(){return m}
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 93593:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[uid]",
      function () {
        return __webpack_require__(46069);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


function SliceManager(param) {
    var slicesClassName = param.slicesClassName, mapSliceTypeToComponent = param.mapSliceTypeToComponent, slicesData = param.slicesData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: slicesData === null || slicesData === void 0 ? void 0 : slicesData.map(function(sliceData, index) {
            var SliceComponent = mapSliceTypeToComponent === null || mapSliceTypeToComponent === void 0 ? void 0 : mapSliceTypeToComponent[sliceData === null || sliceData === void 0 ? void 0 : sliceData.type];
            if (!SliceComponent) return null;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliceComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                className: slicesClassName,
                index: index
            }, sliceData === null || sliceData === void 0 ? void 0 : sliceData.data), index);
        })
    });
}
SliceManager.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (SliceManager);


/***/ }),

/***/ 9222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ asText; }
});

;// CONCATENATED MODULE: ./src/components/Abstracts/Storyblok/as-text.ts
var convertNodeToText = function(richTextField) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " ";
    var result = "";
    for(var i = 0; i < (richTextField === null || richTextField === void 0 ? void 0 : richTextField.length); i++){
        var ref;
        var ref1;
        var richTextContents = (ref1 = (ref = richTextField[i]) === null || ref === void 0 ? void 0 : ref.content) !== null && ref1 !== void 0 ? ref1 : null;
        if (richTextContents) {
            for(var j = 0, k = richTextContents === null || richTextContents === void 0 ? void 0 : richTextContents.length; j < k; j++){
                var currentRichTextContent = richTextContents[j];
                if ("text" in currentRichTextContent) {
                    result += (result ? separator : "") + (currentRichTextContent === null || currentRichTextContent === void 0 ? void 0 : currentRichTextContent.text);
                }
            }
        }
    }
    return result;
};

;// CONCATENATED MODULE: ./src/components/Abstracts/Storyblok/index.ts

var asText = function(structuredText) {
    if (Object.prototype.toString.call(structuredText === null || structuredText === void 0 ? void 0 : structuredText.content) !== "[object Array]") {
        // console.warn(
        //   `Rich text argument should be an Array. Received ${typeof structuredText}`,
        // )
        return null;
    }
    return convertNodeToText(structuredText === null || structuredText === void 0 ? void 0 : structuredText.content);
};



/***/ }),

/***/ 95886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _unlikelystudio_react_abstract_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13200);






function WrapperWithLink(_param) {
    var className = _param.className, children = _param.children, href = _param.href, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "children",
        "href"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_unlikelystudio_react_abstract_components__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            href: href
        }, rest), {
            className: className,
            children: children
        })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            children: children
        })
    });
}
WrapperWithLink.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (WrapperWithLink);


/***/ }),

/***/ 64725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37444);
/* harmony import */ var _types_grid_preset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31538);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95348);
/* harmony import */ var _types_text_styling__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36575);
/* harmony import */ var _components_UI_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51025);
/* harmony import */ var _components_UI_RichText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55071);
/* harmony import */ var _providers_StyleProvider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60118);
/* harmony import */ var _utils_check_empty_string__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86867);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14845);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_9__);












var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default()));
var IMAGE_SIZES = [
    {
        breakpoint: "md",
        ratio: 1 / 2
    },
    {
        ratio: 1
    }
];
function HeroHalf(param) {
    var className = param.className, isReversed = param.isReversed, image = param.image, title = param.title, subtitle = param.subtitle, aboveTheFold = param.aboveTheFold;
    var gridStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_8__/* .useStyle */ .X)({
        grid: _types_grid_preset__WEBPACK_IMPORTED_MODULE_3__/* .GlobalGridPreset.BASE_GRID */ .H.BASE_GRID
    });
    var titleStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_8__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_4__/* .GlobalTextPreset.Title18_24SangBleu */ .C.Title18_24SangBleu,
        color: _types_colors__WEBPACK_IMPORTED_MODULE_2__/* .GlobalThemeColors.Black */ .b.Black
    });
    var subtitleStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_8__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_4__/* .GlobalTextPreset.Text12GroteskMedium */ .C.Text12GroteskMedium,
        textStyling: _types_text_styling__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextStyling.UpperCase */ .l.UpperCase,
        color: _types_colors__WEBPACK_IMPORTED_MODULE_2__/* .GlobalThemeColors.Black */ .b.Black
    });
    var hasContent = (0,_utils_check_empty_string__WEBPACK_IMPORTED_MODULE_10__/* .isRTFilled */ .P)(title) || (0,_utils_check_empty_string__WEBPACK_IMPORTED_MODULE_10__/* .isRTFilled */ .P)(subtitle);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().HeroHalf), className, gridStyle, {
            isReversed: isReversed
        }),
        children: [
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_Image__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().image)),
                layout: "fill",
                objectFit: "cover",
                asPlaceholder: true,
                sizesFromBreakpoints: IMAGE_SIZES,
                priority: aboveTheFold
            }, image)),
            hasContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().contentContainer)),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().content)),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_RichText__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().title), titleStyle),
                            render: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_RichText__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().subtitle), subtitleStyle),
                            render: subtitle
                        })
                    ]
                })
            })
        ]
    });
}
HeroHalf.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (HeroHalf);


/***/ }),

/***/ 96839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37444);
/* harmony import */ var _types_grid_preset__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31538);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95348);
/* harmony import */ var _types_text_styling__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36575);
/* harmony import */ var _components_Abstracts_PopIn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32671);
/* harmony import */ var _components_Popins_ContactPopin__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41709);
/* harmony import */ var _components_UI_Icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54678);
/* harmony import */ var _components_UI_RichText__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55071);
/* harmony import */ var _components_UI_SquaredCta__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35007);
/* harmony import */ var _providers_PopInProvider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18286);
/* harmony import */ var _providers_StyleProvider__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(60118);
/* harmony import */ var _utils_check_empty_string__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(86867);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85935);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_14__);


















var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default()));
function PanelContact(param) {
    var className = param.className, title = param.title, subtitle = param.subtitle, cta = param.cta;
    var gridStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_13__/* .useStyle */ .X)({
        grid: _types_grid_preset__WEBPACK_IMPORTED_MODULE_4__/* .GlobalGridPreset.BASE_GRID */ .H.BASE_GRID
    });
    var titleStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_13__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.Title40SangBleu */ .C.Title40SangBleu
    });
    var subtitleStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_13__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_5__/* .GlobalTextPreset.Text12SangBleu */ .C.Text12SangBleu,
        textStyling: _types_text_styling__WEBPACK_IMPORTED_MODULE_6__/* .GlobalTextStyling.Italic */ .l.Italic
    });
    var ref = (0,_providers_PopInProvider__WEBPACK_IMPORTED_MODULE_12__/* .usePopIn */ .wG)(), addPopin = ref.add;
    var showContactPopin = function() {
        addPopin(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Abstracts_PopIn__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().popin)),
            isCloseButton: true,
            closeButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_Icons__WEBPACK_IMPORTED_MODULE_9__/* .CloseIcon */ .Tw, {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().alertStockIconClose)
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Popins_ContactPopin__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().contactPopin))
            })
        }));
    };
    var hasContent = (0,_utils_check_empty_string__WEBPACK_IMPORTED_MODULE_15__/* .isRTFilled */ .P)(title) || cta || (0,_utils_check_empty_string__WEBPACK_IMPORTED_MODULE_15__/* .isRTFilled */ .P)(subtitle);
    return hasContent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().PanelContact), className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: gridStyle,
            children: [
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_RichText__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    render: title,
                    className: cx(titleStyle, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().title))
                }),
                subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_RichText__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    render: subtitle,
                    className: cx(subtitleStyle, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().subtitle))
                }),
                cta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_SquaredCta__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                    theme: _types_colors__WEBPACK_IMPORTED_MODULE_3__/* .GlobalThemeColors.White */ .b.White,
                    withBackground: true,
                    onClick: showContactPopin,
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_14___default().cta)
                }, cta), {
                    href: null
                }))
            ]
        })
    }) : null;
}
PanelContact.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (PanelContact);


/***/ }),

/***/ 73577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Slices_TwoColumnsLayoutLine; }
});

// UNUSED EXPORTS: TwoColumnsLayoutsTypes

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./src/lib/storyblok-types.ts
var storyblok_types = __webpack_require__(18685);
// EXTERNAL MODULE: ./src/components/UI/PushTitleLink/index.tsx
var PushTitleLink = __webpack_require__(65938);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-abstract-components/dist/es/components/Link/index.js
var Link = __webpack_require__(13200);
// EXTERNAL MODULE: ./src/components/Abstracts/Storyblok/index.ts + 1 modules
var Storyblok = __webpack_require__(9222);
// EXTERNAL MODULE: ./src/components/UI/RichText/index.tsx
var RichText = __webpack_require__(55071);
// EXTERNAL MODULE: ./src/components/UI/Wysiwyg/index.tsx
var Wysiwyg = __webpack_require__(85630);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/components/UI/TwoColumnsHeaderTitle/styles.module.scss
var styles_module = __webpack_require__(8895);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/UI/TwoColumnsHeaderTitle/index.tsx













var cx = bind_default().bind((styles_module_default()));
function TwoColumnsHeaderTitle(param) {
    var className = param.className, title = param.title, subtitle = param.subtitle, date = param.date, categories = param.categories, isHero = param.isHero;
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Title40SangBleu */.C.Title40SangBleu
    });
    var categoryStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskRegular */.C.Text12GroteskRegular
    });
    var dateStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Text12GroteskMedium */.C.Text12GroteskMedium,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx((styles_module_default()).TwoColumnsHeaderTitle, className),
        children: [
            isHero ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: cx((styles_module_default()).title, titleStyle),
                children: (0,Storyblok/* asText */.S)(title)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                className: cx((styles_module_default()).title, titleStyle),
                render: title
            }),
            date && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: cx((styles_module_default()).date, dateStyle),
                children: date
            }),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Wysiwyg/* default */.Z, {
                className: cx((styles_module_default()).subtitle),
                content: subtitle
            }),
            categories && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).categories,
                children: categories === null || categories === void 0 ? void 0 : categories.map(function(category, index) {
                    return /*#__PURE__*/ (0,react.createElement)(Link/* Link */.r, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, category), {
                        key: "category_".concat(index),
                        className: cx((styles_module_default()).category, categoryStyle)
                    }), category));
                })
            })
        ]
    });
}
TwoColumnsHeaderTitle.defaultProps = {};
/* harmony default export */ var UI_TwoColumnsHeaderTitle = (TwoColumnsHeaderTitle);

// EXTERNAL MODULE: ./src/components/UI/TwoColumnsLayout/index.tsx + 5 modules
var TwoColumnsLayout = __webpack_require__(61281);
// EXTERNAL MODULE: ./src/components/Slices/TwoColumnsLayoutLine/styles.module.scss
var TwoColumnsLayoutLine_styles_module = __webpack_require__(21242);
var TwoColumnsLayoutLine_styles_module_default = /*#__PURE__*/__webpack_require__.n(TwoColumnsLayoutLine_styles_module);
;// CONCATENATED MODULE: ./src/components/Slices/TwoColumnsLayoutLine/index.tsx










var TwoColumnsLayoutLine_cx = bind_default().bind((TwoColumnsLayoutLine_styles_module_default()));
var TwoColumnsLayoutsTypes = {
    HALVES: "halves",
    THIRDS: "thirds"
};
function TwoColumnsLayoutLine(param) {
    var className = param.className, layout = param.layout, leftColumn = param.leftColumn, rightColumn = param.rightColumn, isHero = param.isHero;
    var leftColumnComponents = leftColumn === null || leftColumn === void 0 ? void 0 : leftColumn.map(function(_param, i) {
        var type = _param.type, props = (0,_object_without_properties/* default */.Z)(_param, [
            "type"
        ]);
        switch(type){
            case storyblok_types/* STORYBLOK_COMPONENTS.WYSIWYG */.bY.WYSIWYG:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wysiwyg/* default */.Z, (0,_object_spread/* default */.Z)({
                    className: TwoColumnsLayoutLine_cx((TwoColumnsLayoutLine_styles_module_default()).item)
                }, props), "left_column_item_".concat(i));
            case storyblok_types/* STORYBLOK_COMPONENTS.PUSH_TITLE_LINK */.bY.PUSH_TITLE_LINK:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PushTitleLink/* default */.Z, (0,_object_spread/* default */.Z)({
                    className: TwoColumnsLayoutLine_cx((TwoColumnsLayoutLine_styles_module_default()).item)
                }, props), "left_column_item_".concat(i));
            case storyblok_types/* STORYBLOK_COMPONENTS.HERO_TWO_COLS_LAYOUT_TITLE_SUBTITLE */.bY.HERO_TWO_COLS_LAYOUT_TITLE_SUBTITLE:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(UI_TwoColumnsHeaderTitle, (0,_object_spread/* default */.Z)({
                    className: TwoColumnsLayoutLine_cx((TwoColumnsLayoutLine_styles_module_default()).item),
                    isHero: isHero
                }, props), "left_column_item_".concat(i));
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoColumnsLayout/* default */.Z, {
        className: TwoColumnsLayoutLine_cx((TwoColumnsLayoutLine_styles_module_default()).TwoColumnsLayoutLine, className),
        layout: layout,
        leftColumnClassName: TwoColumnsLayoutLine_cx((TwoColumnsLayoutLine_styles_module_default()).leftColumn),
        rightColumnClassName: TwoColumnsLayoutLine_cx((TwoColumnsLayoutLine_styles_module_default()).rightColumn, (TwoColumnsLayoutLine_styles_module_default()) === null || (TwoColumnsLayoutLine_styles_module_default()) === void 0 ? void 0 : (TwoColumnsLayoutLine_styles_module_default())["layout-".concat(rightColumn === null || rightColumn === void 0 ? void 0 : rightColumn.length, "-items")]),
        leftColumnComponents: leftColumnComponents,
        rightColumnComponents: rightColumn
    });
}
TwoColumnsLayoutLine.defaultProps = {};
/* harmony default export */ var Slices_TwoColumnsLayoutLine = (TwoColumnsLayoutLine);


/***/ }),

/***/ 97839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51526);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57891);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_UI_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51025);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69235);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);








var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
function ImageHover(_param) {
    var className = _param.className, isHovering = _param.isHovering, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "className",
        "isHovering"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isImageHoverLoaded = ref[0], setIsImageHoverLoaded = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .AnimatePresence */ .M, {
        children: isHovering && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_7__.m.div, {
            className: cx(className),
            initial: {
                opacity: 0
            },
            animate: isImageHoverLoaded ? {
                opacity: 1,
                transition: {
                    duration: 0.25
                }
            } : {},
            exit: {
                opacity: 0,
                transition: {
                    duration: 0.25
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                onLoadingComplete: function() {
                    setIsImageHoverLoaded(true);
                }
            }, rest))
        })
    });
}
ImageHover.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (ImageHover);


/***/ }),

/***/ 72206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ CARD_IMAGE_LOADER; },
/* harmony export */   "u": function() { return /* binding */ CARD_PRODUCT_LAYOUT; }
/* harmony export */ });
var CARD_PRODUCT_LAYOUT = {
    REGULAR: "regular",
    SMALL_GRID: "small_grid",
    MEDIUM_GRID: "medium_grid",
    BIG_GRID: "big_grid",
    SEARCH_GRID: "search_grid"
};
var CARD_IMAGE_LOADER = {
    STORYBLOK: "storyblok",
    SHOPIFY: "shopify"
};


/***/ }),

/***/ 46069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Shop; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/lib/storyblok-types.ts
var storyblok_types = __webpack_require__(18685);
// EXTERNAL MODULE: ./src/components/Slices/BigTitle/index.tsx
var BigTitle = __webpack_require__(55734);
// EXTERNAL MODULE: ./src/components/Slices/EditorialTitleParagraphCta/index.tsx
var EditorialTitleParagraphCta = __webpack_require__(76791);
// EXTERNAL MODULE: ./src/components/Slices/HeroHalf/index.tsx
var HeroHalf = __webpack_require__(64725);
// EXTERNAL MODULE: ./src/components/Slices/HeroSlider/index.tsx + 1 modules
var HeroSlider = __webpack_require__(88860);
// EXTERNAL MODULE: ./src/components/Slices/PanelContact/index.tsx
var PanelContact = __webpack_require__(96839);
// EXTERNAL MODULE: ./src/components/Slices/ProductsPinsPush/index.tsx
var ProductsPinsPush = __webpack_require__(27733);
// EXTERNAL MODULE: ./src/components/Slices/PushGeneric/index.tsx + 1 modules
var PushGeneric = __webpack_require__(70544);
// EXTERNAL MODULE: ./src/components/Slices/PushTypeListing/index.tsx + 1 modules
var PushTypeListing = __webpack_require__(37923);
// EXTERNAL MODULE: ./src/components/Slices/ThreeColumnsImageWysiwyg/index.tsx
var ThreeColumnsImageWysiwyg = __webpack_require__(54165);
// EXTERNAL MODULE: ./src/components/Slices/TwoColumnsImageTitleWysiwygs/index.tsx
var TwoColumnsImageTitleWysiwygs = __webpack_require__(62549);
// EXTERNAL MODULE: ./src/components/Slices/TwoColumnsLayoutLine/index.tsx + 1 modules
var TwoColumnsLayoutLine = __webpack_require__(73577);
;// CONCATENATED MODULE: ./src/imports/shop_page.ts













var _obj;
/* harmony default export */ var shop_page = (_obj = {}, (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.HERO_SLIDER */.zj.HERO_SLIDER, HeroSlider/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.HERO_HALF */.zj.HERO_HALF, HeroHalf/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.TWO_COLUMNS_LAYOUT_LINE */.zj.TWO_COLUMNS_LAYOUT_LINE, TwoColumnsLayoutLine/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.HEADER_TWO_COLUMNS_LAYOUT */.zj.HEADER_TWO_COLUMNS_LAYOUT, TwoColumnsLayoutLine/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PRODUCTS_PINS_PUSH */.zj.PRODUCTS_PINS_PUSH, ProductsPinsPush/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PUSH_DESIGNERS */.zj.PUSH_DESIGNERS, PushTypeListing/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PUSH_GENERIC */.zj.PUSH_GENERIC, PushGeneric/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.BIG_TITLE */.zj.BIG_TITLE, BigTitle/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.EDITORIAL_TITLE_PARAGRAPH_CTA */.zj.EDITORIAL_TITLE_PARAGRAPH_CTA, EditorialTitleParagraphCta/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.TWO_COLUMNS_IMAGE_TITLE_WYSIWYGS */.zj.TWO_COLUMNS_IMAGE_TITLE_WYSIWYGS, TwoColumnsImageTitleWysiwygs/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.THREE_COLUMNS_IMAGE_WYSIWYG */.zj.THREE_COLUMNS_IMAGE_WYSIWYG, ThreeColumnsImageWysiwyg/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PANEL_CONTACT */.zj.PANEL_CONTACT, PanelContact/* default */.Z), _obj);

// EXTERNAL MODULE: ./src/components/Abstracts/SliceManager/index.tsx
var SliceManager = __webpack_require__(70820);
// EXTERNAL MODULE: ./src/components/PageViewAnalytics/index.tsx
var PageViewAnalytics = __webpack_require__(68971);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react-polyglot/lib/index.js
var lib = __webpack_require__(14408);
// EXTERNAL MODULE: ./src/@types/colors.ts
var colors = __webpack_require__(37444);
// EXTERNAL MODULE: ./src/@types/grid-preset.ts
var grid_preset = __webpack_require__(31538);
// EXTERNAL MODULE: ./src/@types/text-preset.ts
var text_preset = __webpack_require__(95348);
// EXTERNAL MODULE: ./src/@types/text-styling.ts
var text_styling = __webpack_require__(36575);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-slider/dist/es/index.js + 19 modules
var es = __webpack_require__(7924);
// EXTERNAL MODULE: ./src/components/UI/InlineCta/index.tsx + 1 modules
var InlineCta = __webpack_require__(85499);
// EXTERNAL MODULE: ./src/providers/StyleProvider/index.tsx
var StyleProvider = __webpack_require__(60118);
// EXTERNAL MODULE: ./src/data/dictionary/index.ts + 1 modules
var dictionary = __webpack_require__(9554);
// EXTERNAL MODULE: ./src/components/ShopsNavigation/styles.module.scss
var styles_module = __webpack_require__(67821);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/ShopsNavigation/index.tsx














var cx = bind_default().bind((styles_module_default()));
function ShopsNavigation(param) {
    var className = param.className, items = param.items;
    var t = (0,lib/* useTranslate */.qM)();
    var gridStyle = (0,StyleProvider/* useStyle */.X)({
        grid: grid_preset/* GlobalGridPreset.BASE_GRID */.H.BASE_GRID
    });
    var titleStyle = (0,StyleProvider/* useStyle */.X)({
        textPreset: text_preset/* GlobalTextPreset.Label12Grotesk */.C.Label12Grotesk,
        textStyling: text_styling/* GlobalTextStyling.UpperCase */.l.UpperCase
    });
    return (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx((styles_module_default()).ShopsNavigation, className, gridStyle),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cx((styles_module_default()).left, titleStyle),
                children: "".concat(t(dictionary/* GENERAL.SHOPS */.vh.SHOPS), " (").concat(items === null || items === void 0 ? void 0 : items.length, ")")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cx((styles_module_default()).right),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.ZP, {
                    autoIsSlider: true,
                    children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                        var active = item.active, props = (0,_object_without_properties/* default */.Z)(item, [
                            "active"
                        ]);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineCta/* default */.Z, (0,_object_spread/* default */.Z)({
                            className: cx((styles_module_default()).link, {
                                active: active
                            }),
                            textPreset: text_preset/* GlobalTextPreset.Cta12Grotesk */.C.Cta12Grotesk,
                            theme: active ? colors/* GlobalThemeColors.Black */.b.Black : colors/* GlobalThemeColors.Gray */.b.Gray,
                            lineProps: {
                                initialLineState: "none"
                            }
                        }, props), "shop_navigation_".concat(index));
                    })
                })
            })
        ]
    });
}
ShopsNavigation.defaultProps = {};
/* harmony default export */ var components_ShopsNavigation = (ShopsNavigation);

// EXTERNAL MODULE: ./src/pages/shop/styles.module.scss
var shop_styles_module = __webpack_require__(37602);
var shop_styles_module_default = /*#__PURE__*/__webpack_require__.n(shop_styles_module);
;// CONCATENATED MODULE: ./src/pages/shop/[uid].tsx






var __N_SSG = true;
function Shop(param) {
    var slices = param.slices, shopsNavigationItems = param.shopsNavigationItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (shop_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ShopsNavigation, {
                items: shopsNavigationItems
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceManager/* default */.Z, {
                mapSliceTypeToComponent: shop_page,
                slicesData: slices
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageViewAnalytics/* PageViewAnalytics */.W, {
                template: "page"
            })
        ]
    });
}


/***/ }),

/***/ 67821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ShopsNavigation":"styles_ShopsNavigation__N8C4Y","left":"styles_left__WjoU_","right":"styles_right__KwQ_E","link":"styles_link__nTfOG","active":"styles_active__qBq4L"};

/***/ }),

/***/ 14845:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HeroHalf":"styles_HeroHalf__wxMJx","image":"styles_image__9Ju28","contentContainer":"styles_contentContainer__MHMaA","content":"styles_content__hWC3O","isReversed":"styles_isReversed__pgFvg"};

/***/ }),

/***/ 85935:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PanelContact":"styles_PanelContact__Pl0kN","title":"styles_title__6l3NQ","cta":"styles_cta__D8UpW","subtitle":"styles_subtitle__x03_e"};

/***/ }),

/***/ 21242:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"TwoColumnsLayoutLine":"styles_TwoColumnsLayoutLine__RD0Xn","leftColumn":"styles_leftColumn__CIffu","item":"styles_item__YoXY6"};

/***/ }),

/***/ 69235:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8895:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"TwoColumnsHeaderTitle":"styles_TwoColumnsHeaderTitle__kSrH5","date":"styles_date__ukXFA","subtitle":"styles_subtitle__nPJJY","categories":"styles_categories__VeCoa","category":"styles_category__5iHBi"};

/***/ }),

/***/ 37602:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Jkl_8"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7924,3310,4213,2873,5750,6169,1281,5231,9774,2888,179], function() { return __webpack_exec__(93593); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);